module.exports = __webpack_public_path__ + "img/broadband.76ae274.svg";